import React, { useState } from "react";
import { toast } from "react-toastify";
import classNames from "classnames";
import { useUpdateCompareOffersMutation } from "@entities/compare";
import { RefreshIcon } from "@shared/ui/Icon/ui/Common/RefreshIcon";
import { BUTTON_UPDATE_TITLE, TIMEOUT_ANIMATION_BUTTON } from "./constants";
import { UpdatePriceUsdCompareProps } from "./types";
import classes from "./UpdatePriceUsdCompare.module.scss";

export const UpdatePriceUsdCompare = ({ visible, compareId }: UpdatePriceUsdCompareProps) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const [updateCompareOffers, { isLoading }] = useUpdateCompareOffersMutation();

    const handleUpdateOffers = async (event: React.MouseEvent) => {
        event.stopPropagation();
        setIsAnimating(true);
        try {
            await updateCompareOffers(compareId).unwrap();
            toast.success("Стоимость в USD успешно обновлена!");
        } catch (error) {
            toast.error("Ошибка при обновлении стоимости в USD.");
        } finally {
            setTimeout(() => setIsAnimating(false), TIMEOUT_ANIMATION_BUTTON);
        }
    };

    if (!visible) return null;

    return (
        <button
            className={classes["update-price"]}
            onClick={handleUpdateOffers}
            disabled={isLoading}
            title={BUTTON_UPDATE_TITLE}
        >
            <RefreshIcon
                className={classNames(classes["update-price__icon"], {
                    [classes["update-price__icon-rotate"]]: isAnimating
                })}
            />
        </button>
    );
};